import { UTCDate } from '@date-fns/utc';
import { DATE_FORMAT } from '@openx/types/segments';
import { endOfDay, parse } from 'date-fns';

export type ParsedDate = (string | undefined)[];
export const parseDateToISO = (dateRange: string): ParsedDate => {
  if (!dateRange) {
    return [undefined, undefined];
  }

  const fromPrefix = 'from ';
  const toPrefix = 'to ';

  if (dateRange.startsWith(fromPrefix)) {
    const startDate = dateRange.slice(fromPrefix.length).trim();
    const parsedStartDate = parse(startDate, DATE_FORMAT, new UTCDate());

    return [parsedStartDate.toISOString(), undefined];
  }

  if (dateRange.startsWith(toPrefix)) {
    const endDate = dateRange.slice(toPrefix.length).trim();
    const parsedEndDate = parse(endDate, DATE_FORMAT, new UTCDate());

    return [undefined, endOfDay(parsedEndDate).toISOString()];
  }

  const [startDate, endDate] = dateRange.split('-').map(date => date.trim());
  const parsedStartDate = parse(startDate, DATE_FORMAT, new UTCDate());
  const parsedEndDate = parse(endDate, DATE_FORMAT, new UTCDate());

  return [parsedStartDate.toISOString(), endOfDay(parsedEndDate).toISOString()];
};
